import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_ACCOUNT_LIST,
  FETCH_ACCOUNT_LIST_ERROR,
  SET_ACCOUNT_LIST,
} from '../../constants';

const fetchAccountList = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ACCOUNT_LIST),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/accounts?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_ACCOUNT_LIST,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_ACCOUNT_LIST_ERROR,
            error,
          })
        )
      )
    )
  );

export default fetchAccountList;
